(function ($) {


const Init = (() => {

  // settings
  
  
  let website      = {},
      load         = {},
      resize       = {},
      scroll       = {},
      mod          = {},
      scrollOption = {},
      parallax     = {},
      drawer       = {},
      navi         = {},
      iscroll      = {},
      totop        = {},
      json         = {},
      scrollbar    = {},
      canvas       = {},
      tab          = {},
      accordion    = {},
      page         = {},
      header       = {};
  
  website = {
    page          : document.body.dataset.page,
    url           : document.URL,
    winWidth      : window.innerWidth,
    winHeight     : window.innerHeight,
    scrollY       : window.pageYOffset,
    breakpoint    : { 
      ll: 1600,
      lg: 1400,
      md: 1200,
      sm: 992,
      xs: 768,
      ss: 576,
      min: 375,
      accuracy: 0.1,
    },
  
    ua            : navigator.userAgent.toLowerCase(),
    isDesktop     : true,
    isFirst       : true,
    animationFrame: null,
  
    headTag       : document.getElementById('js-header'),
    footTag       : document.getElementById('js-footer'),
  
    act           : 'is-act',
    actOpen       : 'is-open',
  
    tabletView    : 1240,
    isTouchDevice: (window.ontouchstart !== undefined && navigator.maxTouchPoints > 0),
  
    targetAnime : 'js-anime',
    actAnime    : 'is-anime',
    shiftPoint  : 0,
    shiftPc     : 5,
    shiftSp     : 10,
  };
  
  website.shiftPoint = website.breakpoint.tb;
  
  load = {
    functions: [],
    length   : 0,
  };
  
  resize = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  scroll = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  page = {
    common: [],
    top   : [],
  };
  

  //modules
  // サニタイズ関数
  function sanitizing(str){
    var before = new Array('&','"',"'","<",">","\n","\t","\\n");
    var after = new Array('&amp;','&quot;','&rsquo;',"&lt;","&gt;","<br />"," ","<br />");
    for( var i=0; i < before.length; i++ )
      str = str.replace(new RegExp(before[i],'g'), after[i]);
    return str;
  };
  // LOAD
  const WinLoad = {
  
    init() {
      window.addEventListener('load', function(e) {
        WinLoad.update();
      });
  
      console.log('!-- load init --!');
    },
  
    add(func) {
      load.functions.push(func);
      load.length = load.functions.length;
    },
  
    remove(func) {
      load.functions.splice(func, 1);
      load.length = load.functions.length;
    },
  
    update() {
      for ( let i = 0; i < load.length; i++ ) {
        let func = load.functions[i];
        func();
      }
    },
  
  }
  
  // RESIZE
  const WinResize = {
  
    init() {
      window.addEventListener('resize', function(e) {
        if ( !resize.isRunning ) {
          resize.isRunning = true;
  
          resize.animationFrame = window.requestAnimationFrame( WinResize.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinResize.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinResize.update();
          //   }, 1000/resize.fps);
          // }
        }
      });
  
      console.log('!-- resize init --!');
    },
  
    add(func) {
      resize.functions.push(func);
      resize.length = resize.functions.length;
    },
  
    remove(func) {
      resize.functions.splice(func, 1);
      resize.length = resize.functions.length;
    },
  
    update() {
      website.winWidth  = window.innerWidth;
      website.winHeight = window.innerHeight;
      website.ua        = navigator.userAgent.toLowerCase();
  
      for ( let i = 0; i < resize.length; i++ ) {
        let func = resize.functions[i];
        func();
      }
  
      resize.isRunning = false;
    },
  
  }
  
  // SCROLL
  const WinScroll = {
  
    init() {
      window.addEventListener('scroll', function(e) {
        if ( !scroll.isRunning ) {
          scroll.isRunning = true;
  
          scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinScroll.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinScroll.update();
          //   }, 1000/scroll.fps);
          // }
        }
      });
  
      console.log('!-- scroll init --!');
    },
  
    add(func) {
      scroll.functions.push(func);
      scroll.length = scroll.functions.length;
    },
  
    remove(func) {
      scroll.functions.splice(func, 1);
      scroll.length = scroll.functions.length;
    },
  
    update() {
      website.winHeight = window.innerHeight;
      website.scrollY = window.pageYOffset;
  
      for ( let i = 0; i < scroll.length; i++ ) {
        let func = scroll.functions[i];
        func();
      }
  
      scroll.isRunning = false;
    },
  
  }
  
  function easing(t, b, c, d, type='linear') {
    let v = 0;
    switch (type) {
      case 'swing': 
        v = -c *(t/=d)*(t-2) + b;
      break;
      case 'jswing': 
        v = c * (0.5 - Math.cos(t / d * Math.PI) / 2) + b;
      break;
  
      case 'easeInSine': 
        v = -c * Math.cos(t/d * (Math.PI/2)) + c + b;
      break;
      case 'easeOutSine': 
        v = c * Math.sin(t/d * (Math.PI/2)) + b;
      break;
      case 'easeInOutSine': 
        v = -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
      break;
      
      case 'easeInQuad': 
        v = c*(t/=d)*t + b;
      break;
      case 'easeOutQuad': 
        v = -c *(t/=d)*(t-2) + b;
      break;
      case 'easeInOutQuad': 
        v = -c/2 * ((t=t/d-1)*t - 1) + b;
      break;
  
      case 'easeInCubic': 
        v = c*(t/=d)*t*t + b;
      break;
      case 'easeOutCubic': 
        v = c*((t=t/d-1)*t*t + 1) + b;
      break;
      case 'easeInOutCubic':
        if( (t/=d/2) < 1) {
          v = c/2*t*t*t + b;
        } else {
          v = c/2 * ((t=t/d-1)*t*t + 1) + b;
        }
      break;
  
      case 'easeInQuart': 
        v = c*(t/=d)*t*t*t + b;
      break;
      case 'easeOutQuart': 
        v = -c * ((t=t/d-1)*t*t*t - 1) + b;
      break;
      case 'easeInOutQuart': 
        if( (t/=d/2) < 1) {
          v = c/2*t*t*t*t + b;
        } else {
          v = -c/2 * ((t-=2)*t*t*t - 2) + b;
        }
      break;
      
      case 'easeInQuint': 
        v = c*(t/=d)*t*t*t*t + b;
      break;
      case 'easeOutQuint': 
        v = c*((t=t/d-1)*t*t*t*t + 1) + b;
      break;
      case 'easeInOutQuint': 
        if( (t/=d/2) < 1) {
          v = c/2*t*t*t*t*t + b;
        } else {
          v = c/2*((t-=2)*t*t*t*t + 2) + b;
        }
      break;
  
      case 'easeInExpo': 
        v = (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
      break;
      case 'easeOutExpo': 
        v = (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
      break;
      case 'easeInOutExpo': 
        if( t==0 ) {
          v = b;
        } else if( t==d ) {
          v = b+c;
        } else if( (t/=d/2) < 1 ) {
          v = c/2 * Math.pow(2, 10 * (t - 1)) + b;
        } else {
          v = c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
        }
      break;
  
      case 'easeInCirc': 
        v = -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
      break;    
      case 'easeOutCirc': 
        v = c * Math.sqrt(1 - (t=t/d-1)*t) + b;
      break;    
      case 'easeInOutCirc': 
        if( (t/=d/2) < 1 ) {
          v = -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
        } else {
          v = c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
        }
      break;
  
      case 'linear': 
      default:
        v = c * t / d + b;
      break;
    }
    return v;
  }
  
  const Modules = {
  
    init() {
      mod = {
        smooth: {
          target: 'js-scroll',
        },
        totop: {
          target: 'js-totop',
        },
        accordion: {
          target: 'js-accordion',
          targetSP: 'js-accordionSP',
          openElm   : 'js-accordionOpen',
          closeElm   : 'js-accordionClose',
          openClass: 'is-open',
          preOpenClass: 'is-opened',
        },
        print: {
          target: 'js-print',
        },
        tableScroll: {
          wrapperElm: 'js-tableScroll',
          areaElm   : 'js-tableScrollArea',
          iconElm   : 'js-tableScrollIcon',
          targetElm : 'js-tableScrollTarget',
          hintElm   : 'js-tableScrollHint',
          showFlag  : false,
          position: [],
          touchX: 0,
          touchY: 0,
        },
        checkbox: {
          switchTrg: 'js-switchCheckBox',
          collectiveTrg: 'js-collectiveCheckBox',
          toggleTrg: 'js-toggleCheckBox',
        },
        imageScroll: {
          wrapperElm: 'js-imgScroll',
          areaElm: 'js-imgScrollArea',
          iconElm: 'js-imgScrollIcon',
          targetElm: 'js-imgScrollTarget',
          touchX: 0,
          touchY: 0,
        },
        video: {
          target: 'js-video',
          controller: 'js-videoController',
          frame: 'js-videoFrame',
        },
        window: {
          closeBtn: 'js-windowClose',
        },
        consent: {
          wrapperElm: 'js-cookieConsent',
          agreeElm: 'js-cookieConsentAgree',
        }
      };
  
      this.iosCheck();
      this.deviceCheck();
      this.smoothScroll();
      this.toTopInit();
      this.printPage();
      this.collectiveCheckBox();
      this.switchCheckBox();
      this.toggleCheckBox();
      this.videoInit();
      this.windowClose();
      this.cookieConsent();
    },
  
    resizeEvent() {
      Modules.iosCheck();
      Modules.deviceCheck();
      Modules.toTopUpdate();
      Modules.tableScrollView();
      Modules.tableScrollCheck();
      Modules.imageScrollCheck();
    },
  
    scrollEvent() {
      Modules.toTopUpdate();
      Modules.tableScrollView();
      Modules.tableScrollFixed();
    },
  
    loadEvent(){
      Modules.toTopUpdate();
      Modules.setProperty();
      Modules.tableScrollInit();
      Modules.tableScrollView();
      Modules.tableScrollCheck();
      Modules.imageScrollInit();
      Modules.imageScrollCheck();
      Modules.accordionInit();
    },
  
    iosCheck() {
      if (website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)) {
        document.body.classList.add('is-ios');
      } else {
        document.body.classList.remove('is-ios');
      }
    },
  
    deviceCheck() {
      if (
        website.ua.indexOf('iphone') > -1 ||
        website.ua.indexOf('ipod') > -1 ||
        website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
      ) {
        document.body.classList.add('is-sp');
        document.body.classList.remove('is-tb', 'is-pc');
      } else if (
        website.ua.indexOf('ipad') > -1 ||
        website.ua.indexOf('Android') > -1 ||
        (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      ) {
        document.body.classList.add('is-tb');
        document.body.classList.remove('is-pc', 'is-sp');
      } else {
        document.body.classList.add('is-pc');
        document.body.classList.remove('is-tb', 'is-sp');
      }
    },
  
    smoothScroll() {
      document.querySelectorAll('.'+mod.smooth.target+':not([href=""])').forEach((elm) => {
        elm.addEventListener('click', (e) => {
          let href     = elm.getAttribute("href"),
              target   = (href == "#") ? document.documentElement : document.querySelector(href),
              position;
              
          const headerClone = document.getElementById('js-header').cloneNode(true);
          headerClone.classList.add(header.adjustClass);
          headerClone.id = "js-headerClone";
          headerClone.style.zIndex = '1';
          headerClone.style.visibility = 'hidden';
          headerClone.style.pointerEvent = 'none';
          document.body.appendChild(headerClone);
          const headH = headerClone.offsetHeight;
          document.getElementById('js-headerClone').remove();
  
          if(href.match(/^#/)) {
            e.preventDefault();
            shift    = ( (href != "#") ) ? headH : 0;
            position = target.getBoundingClientRect().top + website.scrollY - shift;
            window.scrollTo({
              top: position,
              behavior: 'smooth'
            });
            return false;
          }
        });
      });
    },
  
    setProperty() {
      const root = document.querySelector(':root');
      root.style.setProperty('--scrollbar', website.winWidth - document.body.clientWidth + 'px');
    },
  
    toTopInit() {
      const target = document.querySelectorAll('.' + mod.totop.target);
      target.forEach((elm) => {
        elm.addEventListener('click', (e) => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      });
    },
  
    toTopUpdate() {
      const target = document.querySelectorAll('.' + mod.totop.target);
      if (website.footTag.getBoundingClientRect().top - website.winHeight < 0) {
        for (let i = 0; i < target.length; i++) {
          target[i].parentElement.classList.remove('is-show');
        }
      } else {
        for (let i = 0; i < target.length; i++) {
          target[i].parentElement.classList.add('is-show');
        }
      }
    },
    accordionInit() {
      $('.' + mod.accordion.target + ',' + '.' + mod.accordion.targetSP).each(function(){
        if($(this).hasClass(mod.accordion.preOpenClass)) {
          $(this).removeClass(mod.accordion.preOpenClass).addClass(mod.accordion.openClass);
          $(this).next().show();
        }
      });
      Modules.accordionFunc();
    },
    accordionFunc() {
      $('.' + mod.accordion.target).on('click', function () {
        $(this).toggleClass(mod.accordion.openClass);
        $(this).next().stop().slideToggle(400, 'swing', Modules.tableScrollCheck());
      });
      $('.' + mod.accordion.targetSP).on('click', function () {
        if (website.winWidth < website.breakpoint.sm) {
          $(this).toggleClass(mod.accordion.openClass);
          $(this).next().stop().slideToggle(400, 'swing', Modules.tableScrollCheck());
        }
      });
  
      if($('.' + mod.accordion.openElm).length){
        $('.' + mod.accordion.openElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          let targetClose = $(this).attr('data-accordion-close');
          if( target && $(target).length){
            if ( !$(this).hasClass(website.act) ) {
              $(this).addClass(website.act);
              $(targetClose).addClass(website.act);
              $(target).stop().slideDown();
              return false;
            }
          }
        });
      }
  
      if($('.' + mod.accordion.closeElm).length){
        $('.' + mod.accordion.closeElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          let targetOpen = $(this).attr('data-accordion-open');
          if( target && $(target).length){
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act);
              $(targetOpen).removeClass(website.act);
              $(target).stop().slideUp('fast');
              return false;
            }
          }
        });
      }
    },
  
    tableScrollInit() {
      if(document.querySelectorAll('.' + mod.tableScroll.wrapperElm).length) {
        document.querySelectorAll('.' + mod.tableScroll.wrapperElm).forEach((element,i) => {
          element.querySelector('.'+mod.tableScroll.areaElm).addEventListener('touchstart', (e) => {
            mod.tableScroll.touchX = e.touches[0].pageX;
          });
          element.querySelector('.'+mod.tableScroll.areaElm).addEventListener('touchmove', (e) => {
            const endX = e.changedTouches[0].pageX;
            if(element.querySelector('.'+mod.tableScroll.areaElm).classList.contains('is-scroll')) {
              if(element.querySelector('.'+mod.tableScroll.iconElm)) {
                if(Math.abs(mod.tableScroll.touchX - endX) > 25) {
                  element.querySelector('.'+mod.tableScroll.iconElm).animate([{opacity: 0}],{duration: 400,fill: 'forwards'});
                  setTimeout(() => {
                    element.querySelector('.'+mod.tableScroll.iconElm).style.display = 'none';
                    element.querySelector('.'+mod.tableScroll.iconElm).classList.add('is-hide');
                  },400);
                }
              }
            }
          });
          element.querySelector('.'+mod.tableScroll.areaElm).addEventListener('scroll', (e) => {
            if(element.querySelector('.'+mod.tableScroll.areaElm).classList.contains('is-scroll')) {
              if(element.querySelector('.'+mod.tableScroll.iconElm)) {
                if(element.querySelector('.'+mod.tableScroll.areaElm).scrollLeft > 25 ) {
                  element.querySelector('.'+mod.tableScroll.iconElm).animate([{opacity: 0}],{duration: 400,fill: 'forwards'});
                  setTimeout(() => {
                    element.querySelector('.'+mod.tableScroll.iconElm).style.display = 'none';
                    element.querySelector('.'+mod.tableScroll.iconElm).classList.add('is-hide');
                  },400);
                }
              }
            }
          });
        });
      }
    },
  
    tableScrollView() {
      if(document.querySelectorAll('.' + mod.tableScroll.wrapperElm).length) {
        document.querySelectorAll('.' + mod.tableScroll.wrapperElm).forEach((element) => {
          if(element.querySelector('.'+mod.tableScroll.areaElm).getBoundingClientRect().top - website.winHeight / 2 < 0) {
            element.querySelector('.'+mod.tableScroll.areaElm).classList.add('is-show');
          }
        });
      }
    },
  
    tableScrollCheck() {
      if(document.querySelectorAll('.' + mod.tableScroll.wrapperElm).length) {
        document.querySelectorAll('.' + mod.tableScroll.wrapperElm).forEach((element) => {
          const baseWidth = element.querySelector('.'+mod.tableScroll.areaElm).getBoundingClientRect().width,
                clientWidth = element.querySelector('.'+mod.tableScroll.targetElm).getBoundingClientRect().width;
          if(baseWidth < clientWidth) {
            element.querySelector('.'+mod.tableScroll.areaElm).classList.add('is-scroll');
          }else {
            element.querySelector('.'+mod.tableScroll.areaElm).classList.remove('is-scroll');
          }
        });
      }
    },
    tableScrollFixed() {
      if(document.querySelectorAll('.' + mod.tableScroll.wrapperElm).length) {
        document.querySelectorAll('.' + mod.tableScroll.wrapperElm).forEach((element,i) => {
          if(element.querySelector('.'+mod.tableScroll.areaElm).classList.contains('is-scroll')) {
            if( element.querySelector('.'+mod.tableScroll.iconElm) ) {
              if(element.querySelector('.'+mod.tableScroll.iconElm).getBoundingClientRect().top - website.winHeight / 4 < 0 && !element.querySelector('.'+mod.tableScroll.iconElm).classList.contains('is-hide')){
                element.querySelector('.'+mod.tableScroll.iconElm).animate([{opacity: 0}],{duration: 400,fill: 'forwards'});
                setTimeout(() => {
                  element.querySelector('.'+mod.tableScroll.iconElm).style.display = 'none';
                  element.querySelector('.'+mod.tableScroll.iconElm).classList.add('is-hide');
                },400);
              }
            }
          }
        });
      }
    },
    imageScrollInit(){
      document.querySelectorAll('.'+mod.imageScroll.wrapperElm).forEach((wrapper,i) => {
        const area = wrapper.querySelector('.'+mod.imageScroll.areaElm),
              img = wrapper.querySelector('.'+mod.imageScroll.targetElm);
        let orgWidth = img.querySelector('img').naturalWidth;
        if(wrapper.dataset.imgRate) {
          orgWidth = orgWidth / Number(wrapper.dataset.imgRate);
        }
        img.style.setProperty('--maxWidth',orgWidth+'px');
        if(orgWidth > wrapper.clientWidth) {
          wrapper.classList.add('is-scroll');
        } else {
          wrapper.classList.remove('is-scroll');
        }
        area.addEventListener('touchstart', (e) => {
          mod.imageScroll.touchX = e.touches[0].pageX;
        });
        area.addEventListener('touchmove', (e) => {
          const endX = e.changedTouches[0].pageX;
          if(wrapper.classList.contains('is-scroll')) {
            if(wrapper.querySelector('.'+mod.imageScroll.iconElm)) {
              if(Math.abs(mod.imageScroll.touchX - endX) > 25) {
                wrapper.querySelector('.'+mod.imageScroll.iconElm).animate([{opacity: 0}],{duration: 400,fill: 'forwards'});
                setTimeout(() => {
                  wrapper.querySelector('.'+mod.imageScroll.iconElm).style.display = 'none';
                  wrapper.querySelector('.'+mod.imageScroll.iconElm).classList.add('is-hide');
                },400);
              }
            }
          }
        });
        area.addEventListener('scroll', (e) => {
          if(wrapper.classList.contains('is-scroll')) {
            if(wrapper.querySelector('.'+mod.imageScroll.iconElm)) {
              if(area.scrollLeft > 25 ) {
                wrapper.querySelector('.'+mod.imageScroll.iconElm).animate([{opacity: 0}],{duration: 400,fill: 'forwards'});
                setTimeout(() => {
                  wrapper.querySelector('.'+mod.imageScroll.iconElm).style.display = 'none';
                  wrapper.querySelector('.'+mod.imageScroll.iconElm).classList.add('is-hide');
                },400);
              }
            }
          }
        });
      });
    },
    imageScrollCheck(){
      document.querySelectorAll('.'+mod.imageScroll.wrapperElm).forEach((wrapper,i) => {
        const img = wrapper.querySelector('.'+mod.imageScroll.targetElm);
        let orgWidth = img.querySelector('img').naturalWidth;
        if(wrapper.dataset.imgRate) {
          orgWidth = orgWidth / Number(wrapper.dataset.imgRate);
        }
        if(orgWidth > wrapper.clientWidth) {
          wrapper.classList.add('is-scroll');
        } else {
          wrapper.classList.remove('is-scroll');
        }
      });
    },
    printPage() {
      const target = document.querySelectorAll('.' + mod.print.target);
      target.forEach((elm) => {
        elm.addEventListener('click', (e) => {
          window.print();
        });
      });
    },
    collectiveCheckBox() {
      document.querySelectorAll('.'+mod.checkbox.collectiveTrg).forEach((element) => {
        const target = element.getAttribute('name'),
              checkboxNodes = document.querySelectorAll('input[name="'+target+'"]:not(.'+mod.checkbox.collectiveTrg+')');
        element.addEventListener('change', (e) => {
          if(element.checked) {
            checkboxNodes.forEach((checkbox)=>{
              checkbox.checked = false;
            });
          }
        });
        checkboxNodes.forEach((checkbox)=> {
          checkbox.addEventListener('change', (e) => {
            if(checkbox.checked) {
              element.checked = false;
            }
          });
        });
      });
    },
    switchCheckBox(){
      document.querySelectorAll('.'+mod.checkbox.switchTrg).forEach((element) => {
        element.addEventListener('change', (e) => {
          const target = element.getAttribute('data-target');
          if(element.checked) {
            document.getElementById(target).classList.remove('is-disabled');
            document.getElementById(target).querySelectorAll('input[type="checkbox"]').forEach((elm)=>{
              elm.disabled = false;
            })
          } else {
            document.getElementById(target).classList.add('is-disabled');
            document.getElementById(target).querySelectorAll('input[type="checkbox"]').forEach((elm)=>{
              elm.disabled = false;
              elm.checked = false;
            })
          }
        });
      });
    },
    toggleCheckBox(){
      document.querySelectorAll('.'+mod.checkbox.toggleTrg + '[data-cat="all"]').forEach((element) => {
        const name = element.getAttribute('name');
        element.addEventListener('change',(e) => {
          if(element.checked) {
            document.querySelectorAll('.' + mod.checkbox.toggleTrg+'[name="'+name+'"]:not([data-cat="all"])').forEach((elm)=>{
              elm.checked = false;
              elm.dispatchEvent(new Event('change'));
            });
          }
        });
      });
      document.querySelectorAll('.'+mod.checkbox.toggleTrg + ':not([data-cat="all"])').forEach((element) => {
        const name = element.getAttribute('name');
        element.addEventListener('change',(e) => {
          if(element.checked) {
            document.querySelectorAll('.' + mod.checkbox.toggleTrg+'[name="'+name+'"][data-cat="all"]').forEach((elm)=>{
              elm.checked = false;
              elm.dispatchEvent(new Event('change'));
            });
          }
        });
      });
    },
    videoInit() {
      document.querySelectorAll('.'+mod.video.target).forEach((obj)=>{
        obj.querySelector('.'+mod.video.controller).addEventListener('click',(e)=>{
          if(obj.classList.contains('is-act')) {
            obj.classList.remove('is-act');
            obj.querySelector('.'+mod.video.frame).pause();
          } else {
            obj.classList.add('is-act');
            obj.querySelector('.'+mod.video.frame).play();
          }
        });
      });
    },
    windowClose() {
      if(document.getElementById(mod.window.closeBtn)) {
        document.getElementById(mod.window.closeBtn).addEventListener('click', (e) => {
          window.close();
        });
      }
    },
    cookieConsent() {
      if(!Cookies.get('consent')) {
        $('#'+mod.consent.wrapperElm).fadeIn();
      }
      $('#' + mod.consent.agreeElm).click(function () {
        Cookies.set('consent', '1', { expires: 80 });
        $('#' + mod.consent.wrapperElm).fadeOut();
      });
    }
  }
  
  
  
  const Header = {
    init() {
      header = {
        actClass: 'is-act',
        viewClass: 'is-view',
        adjustClass: 'is-adjust',
        fadeOut: 200,
  
        wrapId: 'js-header',
        megaMenu: 'js-megaMenu',
        megaMenuCont: 'l-header_gnavMega',
  
        searchBtn: 'js-searchBtn',
        searchForm: 'js-searchForm',
        scrollCurrent: 0,
  
        checkCurrent : 'js-checkCurrentPage',
        currentClass: 'is-current',
      }
      // this.scrollUpView();
      this.scrollSizeAdjust();
      this.megaMenuInit();
      this.searchFormInit();
      this.checkCurrentPage();
    },
    resizeEvent() {
  
    },
    loadEvent() {
  
    },
    scrollEvent() {
      // Header.scrollUpView();
      Header.scrollSizeAdjust();
    },
    scrollUpView() {
      if (website.scrollY === header.scrollCurrent) {
        return;
      }
  
      if (website.scrollY <= 10 || website.scrollY < header.scrollCurrent) {
        website.headTag.classList.add(header.viewClass);
      } else {
        website.headTag.classList.remove(header.viewClass);
      }
  
      header.scrollCurrent = website.scrollY;
    },
    scrollSizeAdjust() {
      if (website.scrollY < 100) {
        website.headTag.classList.remove(header.adjustClass);
      } else {
        website.headTag.classList.add(header.adjustClass);
      }
    },
    megaMenuInit() {
      let nodeList = document.querySelectorAll('.' + header.megaMenu),
        timer = {};
  
      nodeList.forEach((target, index) => {
        timer[index] = null;
        target.addEventListener(`mouseenter`, () => {
          if (website.winWidth >= website.breakpoint.md) {
            clearTimeout(timer[index]);
            website.headTag.classList.add(header.actClass);
            target.classList.add(header.actClass);
          }
        });
        target.addEventListener(`mouseleave`, () => {
          if (website.winWidth >= website.breakpoint.md) {
            timer[index] = setTimeout(
              function () {
                target.classList.remove(header.actClass);
  
                let flag = true;
                nodeList.forEach((target, index) => {
                  if (target.classList.contains(header.actClass) === true) {
                    flag = false;
                  }
                });
                if (flag) {
                  website.headTag.classList.remove(header.actClass);
                }
              },
              header.fadeOut);
          }
        });
  
        target.addEventListener(`click`, function (e) {
          if (website.winWidth < website.breakpoint.md) {
            if (target.classList.contains(header.actClass) === true) {
              target.classList.remove(header.actClass);
              $(target).children('.' + header.megaMenuCont).stop().slideUp();
            } else {
              target.classList.add(header.actClass);
              $(target).children('.' + header.megaMenuCont).stop().slideDown();
            }
          }
        });
      });
    },
    searchFormInit() {
      let btnElm = document.querySelector('.' + header.searchBtn),
        formElm = document.querySelector('.' + header.searchForm),
        timer = null;
      if(btnElm && formElm) {
        btnElm.addEventListener(`click`, function (e) {
          if (btnElm.classList.contains(header.actClass) === true) {
            btnElm.classList.remove(header.actClass);
            formElm.classList.remove(header.actClass);
          } else {
            btnElm.classList.add(header.actClass);
            formElm.classList.add(header.actClass);
          }
        });
      }
    },
    checkCurrentPage() {
      const path = location.pathname;
      document.querySelectorAll('.'+header.checkCurrent).forEach((element, index) => {
        const pattern = element.getAttribute('data-pattern');
        const reg = path.match(/^\/en\//g) ? new RegExp(`^/en${pattern}`) : new RegExp(`^${pattern}`) ;
  
        if(reg.test(path)) element.classList.add(header.currentClass);
      });
    },
  }
  const DrawerMenu = {
    init() {
      drawer = {
        duration: 10,
        menu: 'js-drawerMenu',
        menuPanel: 'js-drawerMenuPanel',
        menuToggle: '#js-drawerMenuToggle',
        menuClose: '#js-drawerMenuPanel, #js-drawerMenu .js-scroll',
      };
  
      this.menu();
    },
  
    menu() {
      if (document.getElementById(drawer.menu) != null) {
        let slideoutInst = new Slideout({
          'panel': document.getElementById(drawer.menuPanel),
          'menu': document.getElementById(drawer.menu),
          'duration': drawer.duration,
          // 'openclass': drawer.menuAct,
        });
  
        let nodeList = document.querySelectorAll(drawer.menuToggle);
        let node = Array.prototype.slice.call(nodeList, 0);
        node.forEach(function (elem, index) {
          elem.addEventListener('click', function () {
            slideoutInst.toggle();
          });
        });
  
        let nodeListClose = document.querySelectorAll(drawer.menuClose);
        let nodeClose = Array.prototype.slice.call(nodeListClose, 0);
        nodeClose.forEach(function (elem, index) {
          elem.addEventListener('click', function () {
            slideoutInst.close();
          });
        });
      }
    },
  
  }
  
    const Animation = {
  
      init() {
      },
  
      check() {
        $('.' + website.targetAnime + ':not(.' + website.actAnime + ')').each(function(){
          let self = $(this),
              targetPosition = self.offset().top,
              triggerPosition,
              shift;
  
          if( website.winWidth < website.shiftPoint ) {
            shift = website.winHeight / website.shiftSp;
          } else {
            shift = website.winHeight / website.shiftPc;
          }
          triggerPosition = targetPosition - website.winHeight + shift;
  
          if( website.scrollY > triggerPosition ){
            self.addClass(website.actAnime);
          }
        });
      },
  
    }
  
  const Tab = {
    init() {
      tab = {
        wrapperElm: 'js-tabWrapper',
        selectElm: 'js-tabSelect',
        triggerElm: 'js-tabTrigger',
        containerElm: 'js-tabContainer',
        openClass: 'is-open',
        actClass: 'is-act',
      };
      this.update();
      this.select();
      this.set();
    },
    set() {
      $('.'+tab.wrapperElm).each(function(){
        if( location.hash && $(this).find('.'+tab.triggerElm).find('a[href="'+ location.hash +'"]').length === 1 ) { 
          $(this).find('.'+tab.triggerElm).find('a[href="'+ location.hash +'"]').click();
          if( location.search ) {
            const anchor = new URLSearchParams(location.search).get('anchor');
            if($(location.hash).find(`#${anchor}`).length) {
              const target = $(location.hash).find(`#${anchor}`).offset().top;
              const headerClone = document.getElementById('js-header').cloneNode(true);
              headerClone.classList.add(header.adjustClass);
              headerClone.id = "js-headerClone";
              headerClone.style.zIndex = '1';
              headerClone.style.visibility = 'hidden';
              headerClone.style.pointerEvent = 'none';
              document.body.appendChild(headerClone);
              const headH = headerClone.offsetHeight;
              document.getElementById('js-headerClone').remove();
              setTimeout(function() {
                window.scrollTo(0,target - headH);
              },400);
  
            }
          } 
        } else if( $(this).find('.'+tab.triggerElm).find('a.is-act').length === 1 ) {
          $(this).find('.'+tab.triggerElm).find('a.is-act').click();
        } else {
          $(this).find('.'+tab.triggerElm).children().eq(0).find('a').click();
        }
      });
    },
    update(){
      $('.'+tab.triggerElm).find('a').on('click', function(e){
        let target = $(this).attr('href'), select = $(this).text();
        let scrollY = website.scrollY;
        $(this).parent().siblings().find('a').removeClass(tab.actClass);
        $(this).addClass(tab.actClass);
        if($(this).closest('.'+tab.wrapperElm).data('pulldown') === true){
          $(this).closest('.'+tab.wrapperElm).find('.'+tab.selectElm).removeClass(tab.openClass).html('<span>'+ select +'</span>');
          if(website.winWidth < website.breakpoint.xs) {
            $(this).closest('.'+tab.triggerElm).slideUp();
          }
        }
        $(this).closest('.'+tab.wrapperElm).children('.'+tab.containerElm).children().hide().removeClass(website.actClass);
        $(this).closest('.'+tab.wrapperElm).children('.'+tab.containerElm).find(target).fadeIn(400).addClass(website.actClass);
        Modules.tableScrollCheck();
        return false;
      });
    },
    select(){
      $('.'+tab.selectElm).on('click', function(e){
        $(this).toggleClass(tab.openClass);
        $(this).closest('.'+tab.wrapperElm).find('.'+tab.triggerElm).slideToggle()
      });
    },
  }
  const Json = {
    init() {
      json = {
        sortElms: document.getElementsByClassName('js-jsonSortTag'), 
        loadElm: document.getElementById('js-jsonLoad'),
        outputElm: document.getElementById('js-jsonOutput'),
        src: '/communication/insight/data.json',
        html: document.getElementById('js-jsonHtmlFormat')
      }
      if(json.outputElm) {
        this.func();
      }
    },
    func() {
      let jsonData;
      const request = new XMLHttpRequest();
      request.open('GET', json.src, true);
      request.responseType = 'text';
      request.send();
      request.onload =  function() {
        const jsonData = JSON.parse(request.responseText);
        if(json.outputElm.dataset.category) {
          json.allItems = jsonData.filter(item => item.category === json.outputElm.dataset.category);
        } else {
          json.allItems = jsonData;
        }
        json.currentItems = json.allItems.map(item => item);
        Json.output();
        Json.load();
        Json.sort();
      }
    },
    sort() {
      for(let i = 0; i < json.sortElms.length; i++) {
        json.sortElms[i].addEventListener('click', (e)=>{
          const tag = json.sortElms[i].dataset.tag;
          json.outputElm.innerHTML = '';
          if(json.loadElm) {
            json.loadElm.classList.remove('is-disabled');
          }
          if ( tag == 'all' ) {
            json.currentItems = json.allItems.map(item => item);
          } else {
            json.currentItems = json.allItems.filter(item => item.tags.some(t => t === tag));
          }
          for(let i = 0; i < json.sortElms.length; i++) {
            if(json.sortElms[i].classList.contains('is-current')) {
              json.sortElms[i].classList.remove('is-current');
            }
          }
          json.sortElms[i].classList.add('is-current');
          Json.output();
        });
      }
    },
    load() {
      if(json.loadElm) {
        json.loadElm.addEventListener('click', (e)=>{
          Json.output();
          if(json.currentItems.length == 0) {
            json.loadElm.classList.add('is-disabled');
          }
        });
      }
    },
    output() {
      let html = "\n";
      let format = json.html.textContent;
      const max = json.loadElm ? (json.loadElm.dataset.nums < json.currentItems.length ? json.loadElm.dataset.nums : json.currentItems.length) : json.currentItems.length;
      let today = new Date();
      today.setDate(today.getDate() - 14);
      const time = {h: today.getHours(),i: today.getMinutes(),s: today.getSeconds()};
      if(json.currentItems.length) {
        for(let i = 0; i < max; i++) {
          const item = json.currentItems.pop();
          const formatDate = {  
            y: item.created.replace(/([0-9]{4})年([0-1][0-9])月([0-3][0-9])日/g, '$1'),
            m: item.created.replace(/([0-9]{4})年([0-1][0-9])月([0-3][0-9])日/g, '$2'),
            d: item.created.replace(/([0-9]{4})年([0-1][0-9])月([0-3][0-9])日/g, '$3'),
          };
          let date = new Date(formatDate.y, formatDate.m - 1, formatDate.d, time.h, time.i, time.s);
          html += format.replace(/%title%/g, item.title)
                        .replace(/%url%/g, item.url)
                        .replace(/%new%/g, date >= today ? '--new' : '')
                        .replace(/%date%/g, item.created)
                        .replace(/%target%/g, item.target ? 'target="_blank"' : '')
                        .replace(/%category%/g, item.category)
                        .replace(/%tag%/g, item.tags.join('</span><span>'))
                        .replace(/%thumbnail%/g, item.thumbnail);
          html += "\n";
        }    
        json.outputElm.innerHTML += html;
      } else {
        json.outputElm.innerHTML = '<p class="p-columnArchive__error">該当する記事がありません。</p>';
        if(json.loadElm) {
          json.loadElm.classList.add('is-disabled');
        }
      }
      if(!json.currentItems.length) {
        if(json.loadElm) {
          json.loadElm.classList.add('is-disabled');
        }
      }
    }
  }

  // page
  const BasicPage = {
    init() {
      page.common = {
        topics: {
          sliderElm: document.getElementById('js-sliderTopics'),
          options: {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            gap: '2.4rem',
            autoplay: true,
            interval: 5000,
            pagination: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            breakpoints: {
              991.9: {
                perPage: 2,
              },
              767.9: {
                perPage: 1,
                gap: '1.2rem',
                padding: { left: '1.2rem', right: '1.2rem' }
              },
            },
          }
        },
        business: {
          sliderElms: document.getElementsByClassName('js-sliderBusiness'),
          options: {
            type: 'fade',
            rewind: true,
            // perPage: 1,
            // perMove: 1,
            // gap: 5,
            speed: 600,
            autoplay: true,
            interval: 3000,
            pagination: false,
            pauseOnHover: false,
            pauseOnFocus: false,
          }
        },
        column: {
          index: {
            sliderElm: document.getElementById('js-sliderColumn'),
            options: {
              type: 'loop',
              autoWidth: true,
              perMove: 1,
              gap: '4rem',
              autoplay: true,
              interval: 5000,
              pagination: false,
              pauseOnHover: false,
              pauseOnFocus: false,
              breakpoints: {
                991.9: {
                  autoWidth: false,
                  perPage: 2,
                  gap: '3rem',
                },
                767.9: {
                  autoWidth: false,
                  perPage: 1,
                  gap: '2rem',
                },
              },
            }
          },
          pickup: {
            sliderElm: document.getElementById('js-sliderColumnPickup'),
            options: {
              type: 'fade',
              rewind: true,
              // perPage: 1,
              // perMove: 1,
              // gap: 5,
              // autoplay: true,
              // interval: 5000,
              pagination: true,
              pauseOnHover: false,
              pauseOnFocus: false,
            }
          },
          detail: {
            sliderElm: document.getElementById('js-sliderColumnDetail'),
            options: {
              type: 'loop',
              perPage: 1,
              perMove: 1,
              gap: '1.2rem',
              autoplay: true,
              interval: 5000,
              pagination: false,
              pauseOnHover: false,
              pauseOnFocus: false,
              mediaQuery: 'min',
              breakpoints: {
                992: {
                  perPage: 3,
                },
                768: {
                  perPage: 2,
                  padding: 0,
                  gap: '4rem',
                },
              },
            }
          },
        }
      };
  
      this.topicsSlider();
      this.BusinessSlider();
      this.columnSlider();
      this.columnPickupSlider();
      this.columnDetailSlider();
      // this.langToggle();
    },
  
    topicsSlider() {
      if (page.common.topics.sliderElm != null) {
        const slider = new Splide(page.common.topics.sliderElm, page.common.topics.options);
        slider.mount();
      }
    },
  
    BusinessSlider() {
      if (page.common.business.sliderElms != null) {
        const slideNum = page.common.business.sliderElms.length;
        for (let i = 0; i < slideNum; i++) {
          const slider = new Splide(page.common.business.sliderElms[i], page.common.business.options);
          slider.mount();
        }
      }
    },
    columnSlider() {
      if (page.common.column.index.sliderElm != null) {
        const slider = new Splide(page.common.column.index.sliderElm, page.common.column.index.options);
        slider.mount();
      }
    },
    columnPickupSlider() {
      if (page.common.column.pickup.sliderElm != null) {
        const slider = new Splide(page.common.column.pickup.sliderElm, page.common.column.pickup.options);
        slider.mount();
      }
    },
    columnDetailSlider() {
      if (page.common.column.detail.sliderElm != null) {
        const length = page.common.column.detail.sliderElm.getElementsByClassName('splide__slide').length;
        if(length === 3) {
          page.common.column.detail.options.breakpoints[992].destroy = true;
        } else if(length === 2) {
          page.common.column.detail.options.breakpoints[768].destroy = true;
        } else if(length === 1) {
          page.common.column.detail.options.destroy = true;
        }
        const slider = new Splide(page.common.column.detail.sliderElm, page.common.column.detail.options);
        slider.mount();
      }
  
    },
    update() {
    },
    // langToggle() {
    //   if (location.href.match('english')) {
    //     $('.l-header__langAnc').removeClass('--active');
    //     $('.l-header__langAnc[href="/english/"]').addClass('--active');
    //   }
    // },
  }
  
  const Home = {
    init() {
      page.home = {
        hero: {
          sliderElm: 'js-home__hero-slider',
          controllerElm: 'js-home__hero-slider-controller',
          statusElm: 'js-home__hero-slider-status'
        },
        topics: {
          sliderElm: 'js-home__topics-slider',
          fakeElm: 'js-home__topics-slider-fake',
          progressElm: 'js-home__topics-slider-progress',
          arrowsElm: 'js-home__topics-slider-arrow',
          options: {
            speed: 1000,
            autoplaySpeed: 5000
          }
        },
        news: {
          tabTrgWrap: 'js-home__news-tab-trigger',
          tabContWrap: 'js-home__news-tab-content',
          actClass: 'is-show'
        },
        business: {
          linkElm: 'js-home__business-link',
        },
      }
      this.heroSlider();
      if(document.getElementById(page.home.topics.sliderElm)) {
        this.topicsInit();
        this.topicsSlider();
      }
      if(document.getElementById(page.home.news.tabTrgWrap) && document.getElementById(page.home.news.tabContWrap)) {
        this.newsInit();
        this.newsTabUpdate();
      }
      this.businessInit();
    },
    heroSlider() {
      let interval = 5000;
      const controller = document.getElementById(page.home.hero.controllerElm);
      const status = document.getElementById(page.home.hero.statusElm);
      const slider = new Splide('#' + page.home.hero.sliderElm, {
        type: 'fade',
        autoplay: 'pause',
        speed: 1000,
        rewind: true,
        interval: interval,
        pauseOnHover: false,
        pauseOnFocus: false,
        video: {
          autoplay: true,
          hideControls: true,
          mute: true,
          drag: false,
          disableOverlayUI: true,
          playerOptions: {
            htmlVideo: {
              autoplay: true,
              controls: false,
              loop: true,
              muted: true,
              playsInline: true,
              poster: './assets/img/top/top_poster_kv_01.jpg',
              preload: 'metadata'
            }
          }
        }
      });
      slider.on('mounted', () => {
        status.innerHTML = '1 / ' + slider.Components.Elements.slides.length;
        slider.Components.Pagination.items.forEach((elm, i) => {
          elm.button.style.transitionDuration = interval + 'ms';
          elm.button.classList.remove('is-active');
        });
      });
      slider.on('ready', () => {
        slider.Components.Autoplay.play();
        slider.Components.Pagination.items[0].button.classList.add('is-active');
        controller.classList.remove('is-paused');
        controller.addEventListener('click', () => {
          if (slider.Components.Autoplay.isPaused()) {
            slider.Components.Autoplay.play();
            controller.classList.remove('is-paused');
          } else {
            slider.Components.Autoplay.pause();
            controller.classList.add('is-paused');
          }
        });
      });
      slider.on('moved', (newidx, previdx, dest) => {
        status.innerHTML = (newidx + 1) + ' / ' + slider.Components.Elements.slides.length;
      });
      slider.mount(window.splide.Extensions);
  
    },
    topicsInit(){
      let cloneSlide, length;
      length = $('#' + page.home.topics.sliderElm).children().length;
      while (length < 5) {
        $('#' + page.home.topics.sliderElm).children().clone(true).appendTo('#' + page.home.topics.sliderElm);
        length = $('#' + page.home.topics.sliderElm).children().length;
      }
      $('#' + page.home.topics.sliderElm).children().clone(true).appendTo('#' + page.home.topics.fakeElm);
  
      cloneSlide = $('#' + page.home.topics.fakeElm).children();
      $('#' + page.home.topics.fakeElm).children().each(function (i) {
        $(this).attr('slide-index', i);
      });
      $('#' + page.home.topics.fakeElm).children().clone(true).each(function (i) {
        let index = -cloneSlide.length + i;
        $(this).attr('slide-index', index);
      }).prependTo('#' + page.home.topics.fakeElm);
      $('#' + page.home.topics.fakeElm).children().css('transition-duration', page.home.topics.options.speed + 'ms');
    },
    topicsSlider(){
  
      $('#' + page.home.topics.sliderElm).on('init', function (e, slick) {
        $('#' + page.home.topics.progressElm).children('span').animate({ width: '0%' }, 0, 'linear').animate({ width: '100%' }, page.home.topics.options.autoplaySpeed, 'linear');
      }).slick({
        // autoplay: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: page.home.topics.options.autoplaySpeed,
        speed: page.home.topics.options.speed,
        swipe: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        dots: false,
        appendArrows: $('#' + page.home.topics.arrowsElm),
        // rtl: true,
        responsive: [
          {
            breakpoint: website.breakpoint.sm,
            settings: {
              fade: false,
              swipe: true,
              slidesToShow: 2,
            }
          },
          {
            breakpoint: website.breakpoint.xs,
            settings: {
              fade: false,
              swipe: true,
              slidesToShow: 1,
            }
          }
        ],
      }).on('beforeChange', function (e, slick, currentSlide, nextSlide) {
        $('#' + page.home.topics.progressElm).children('span').stop().animate({ width: '0%' }, 0, 'linear');
        if (Math.abs(currentSlide - nextSlide) > 1) {
          if (currentSlide - nextSlide > 0) {
            let index = parseInt($('#' + page.home.topics.fakeElm).children().first().attr('slide-index'));
            $('#' + page.home.topics.fakeElm).children().first().clone(true).appendTo('#' + page.home.topics.fakeElm)
            $('#' + page.home.topics.fakeElm).children().first().remove();
            $('#' + page.home.topics.fakeElm).children().first().attr('slide-index', index);
            $('#' + page.home.topics.fakeElm).children().first().nextAll().each(function (i) {
              $(this).attr('slide-index', index + i + 1);
            });
          } else if (currentSlide - nextSlide < 0) {
            let index = parseInt($('#' + page.home.topics.fakeElm).children().last().attr('slide-index'));
            $('#' + page.home.topics.fakeElm).children().last().clone(true).prependTo('#' + page.home.topics.fakeElm)
            $('#' + page.home.topics.fakeElm).children().last().remove();
            $('#' + page.home.topics.fakeElm).children().last().attr('slide-index', index);
            $('#' + page.home.topics.fakeElm).children().last().prevAll().each(function (i) {
              $(this).attr('slide-index', index - i - 1);
            });
          }
        } else {
          if (currentSlide - nextSlide < 0) {
            let index = parseInt($('#' + page.home.topics.fakeElm).children().first().attr('slide-index'));
            $('#' + page.home.topics.fakeElm).children().first().clone(true).appendTo('#' + page.home.topics.fakeElm)
            $('#' + page.home.topics.fakeElm).children().first().remove();
            $('#' + page.home.topics.fakeElm).children().first().attr('slide-index', index);
            $('#' + page.home.topics.fakeElm).children().first().nextAll().each(function (i) {
              $(this).attr('slide-index', index + i + 1);
            });
          } else if (currentSlide - nextSlide > 0) {
            let index = parseInt($('#' + page.home.topics.fakeElm).children().last().attr('slide-index'));
            $('#' + page.home.topics.fakeElm).children().last().clone(true).prependTo('#' + page.home.topics.fakeElm)
            $('#' + page.home.topics.fakeElm).children().last().remove();
            $('#' + page.home.topics.fakeElm).children().last().attr('slide-index', index);
            $('#' + page.home.topics.fakeElm).children().last().prevAll().each(function (i) {
              $(this).attr('slide-index', index - i - 1);
            });
          }
        }
      }).on('afterChange', function (e, currentSide) {
        $('#' + page.home.topics.progressElm).children('span').animate({ width: '100%' }, page.home.topics.options.autoplaySpeed, 'linear');
      });
    },
    newsInit() {
      let targetElm = document.getElementById(page.home.news.tabTrgWrap).children[0];
      targetElm.classList.add(page.home.news.actClass);
      const target = targetElm.getAttribute('href');
      this.newsTabChange(target);
    },
    newsTabUpdate(){
      let trigger = document.getElementById(page.home.news.tabTrgWrap).children;
      for (let i = 0; i < trigger.length; i++) {
        trigger[i].addEventListener('click', (e) => {
          e.preventDefault();
          for (let j = 0; j < trigger.length; j++) {
            trigger[j].classList.remove(page.home.news.actClass);
          }
          let target = trigger[i].getAttribute('href');
          trigger[i].classList.add(page.home.news.actClass);
          this.newsTabChange(target);
        })
      }
    },
    newsTabChange(target){
      $('#' + page.home.news.tabContWrap).children().hide().removeClass(page.home.news.actClass);
      $(target).fadeIn().addClass(page.home.news.actClass);
    },
    businessInit(){
      const links = document.querySelectorAll('.' + page.home.business.linkElm);
      links.forEach((link) => {
        if (!website.isTouchDevice) {
          link.addEventListener('mouseover', (e) => {
            link.classList.add('is-hover');
          })
          link.addEventListener('mouseout', (e) => {
            link.classList.remove('is-hover');
          })
        } else {
          link.addEventListener('click', (e) => {
            if (!link.classList.contains('is-hover') && website.winWidth >= website.breakpoint.sm) {
              e.preventDefault();
              links.forEach((elm) => {
                elm.classList.remove('is-hover');
              });
              link.classList.add('is-hover');
            }
          })
        }
      });
    },
  }
  



  const App = {

    init() {
      if ( website.page != 'wp-manual' && website.page != 'wp-manual-single' ) {
        this.set();
        // this.update();
      } else {
        // Modules.init();
        // Wordpress.init();
      }
    },

    set() {

      if(location.hostname === 'localhost') {
        Array.from(document.getElementsByTagName('a')).forEach((elm) => {
          elm.addEventListener('click', (e) => {
            if(elm.href.indexOf('https://tatemono.com') > -1) {
              e.preventDefault();
              window.location.href = elm.href.replace('https://tatemono.com', '');
            }
          });
        });
      }

      Modules.init();
      DrawerMenu.init();
      Header.init();
      Tab.init();
      BasicPage.init();
      Json.init();


      if ( website.page == 'top' ) {
        Home.init();
      }

      // loaded
      WinLoad.add( Animation.check );
      WinLoad.add( Modules.loadEvent );

      // resize
      WinResize.add( Modules.resizeEvent );

      // scroll
      WinScroll.add( Animation.check );
      WinScroll.add( Modules.scrollEvent );
      WinScroll.add( Header.scrollEvent );


      WinLoad.init();
      WinResize.init();
      WinScroll.init();

    },

    // update() {
    //   website.animationFrame = window.requestAnimationFrame( App.update );
    //   website.winWidth       = window.innerWidth;
    //   website.winHeight      = window.innerHeight;
    //   website.scrollY        = window.pageYOffset;

    //   if ( website.isDesktop ) {
    //     PageScroll.smooth();

    //     if ( website.page == 'top' ) {
    //       Parallax.moveImg();
    //     }
    //   }
    // },

  }


  App.init();

})();


})(jQuery);
